import React from 'react';

interface IconProps {
  className?: string;
  size?: number;
}

export const DunesIcon: React.FC<IconProps> = ({ className, size = 24 }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.5"
    strokeLinecap="round"
    strokeLinejoin="round"
    className={className}
  >
    {/* Dunes - rolling sand hills */}
    <path d="M2 20c4-8 8-12 12-8s6 4 8-4" />
    <path d="M2 20h20" />
    <path d="M6 16c2-4 4-4 6-2" />
    <circle cx="18" cy="6" r="2" />
  </svg>
);
